import { Controller } from "@hotwired/stimulus"

// Toggles the public header's hamburger menu on narrow screens.
export default class extends Controller {
  static targets = ["panel"]

  toggle(event) {
    const open = this.panelTarget.classList.toggle("open")
    event.currentTarget.setAttribute("aria-expanded", open)
  }
}
